import { MOBILE_SIZE } from '@osn/constants';

// src/utils/responsive.js
var SM_SIZE = 768;
var MD_SIZE = 1024;
var LG_SIZE = 1280;
var mobilecss = (css) => makeResponsive(css, MOBILE_SIZE);
var smcss = (css) => makeResponsive(css, SM_SIZE);
var mdcss = (css) => makeResponsive(css, MD_SIZE);
var lgcss = (css) => makeResponsive(css, LG_SIZE);
function makeResponsive(css, breakpoint) {
  return `@media (max-width: ${breakpoint}px) {
    ${css}
  }`;
}

export { LG_SIZE, MD_SIZE, SM_SIZE, lgcss, mdcss, mobilecss, smcss };
